import { maskit } from './maskit';
import { DynamicMask } from './types';

export const dynamicMask: DynamicMask = (masks, masked) => {
  const localMasks = [...masks].sort((a, b) => a.length - b.length);

  return (value: string) => {
    for (let i = 0; i < localMasks.length; ) {
      const currentMask = localMasks[i];
      const nextMask = localMasks[++i];

      if (!(nextMask && maskit(value, nextMask, true).length > currentMask.length)) {
        return maskit(value, currentMask, masked);
      }
    }
    return '';
  };
};
